import BaseApiAction from '@Actions/base-api-action';

export default class SecureValidateUserEmail extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'secure-secureValidateUserEmail',
      payload: {
        user_id: this._payload.user_id
      },
    });
  }

  onSuccess(data) {
    super.onSuccess(data);
  }
}
